import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { HeaderService } from './header.service';
import { UserDetailsService } from './user-details.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DerivativeSrcPrdService {
  apiURL = environment.oneLogApi;
  constructor(
    private http: HttpClient,
    private userDetails: UserDetailsService,
    private headerService: HeaderService
  ) {}

  postRequest(
    postData: any = [],
    getData: string = '',
    url: string = ''
  ): Observable<any> {
    const headerDict = {
      'content-type': 'application/json',
      Authorization: this.userDetails.getUserToken(),
      userToken: this.userDetails.getUser(),
    };

    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    const body = JSON.stringify(postData);
    console.log(this.apiURL + url + getData, postData, requestOptions);
    return this.http
      .post<any>(this.apiURL + url + getData, postData, requestOptions)
      .pipe(retry(1), catchError(this.handleError));
  }

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
